/** @format */

/**
 * @param key the key of the cookie to be found
 * @returns the cookie found or undefined
 */
export function findCookie(key: string) {
  return document.cookie
    .split(";")
    .map((cookie) => {
      const cookieParts = cookie.split("=");
      if (
        cookieParts.length !== 2 ||
        typeof cookieParts[0] !== "string" ||
        typeof cookieParts[1] !== "string"
      )
        return undefined;

      return { key: cookieParts[0].trim(), val: cookieParts[1].trim() };
    })
    .find((cookie) => {
      return cookie !== undefined && cookie.key === key;
    });
}
